import styled from 'styles/styled';

export const ChainGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-top: 10px;
  margin-bottom: 22px;
  width: 100%;
  @media (min-width: 768px) {
    margin-bottom: 26px;
  }
`;

export const ChainTile = styled.button<{ selected: boolean }>`
  appearance: none;
  background: #292B2E;
  color: ${({ selected }) => (selected ? '#52D381' : '#EFEFEF')};
  border: 1px solid ${({ selected }) => (selected ? '#52D381' : '#34373C')};
  border-radius: 10px;
  min-height: 60px;
  padding: 10px 14px;
  flex: 0 1 calc(50% - 5px);
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: border-color 120ms ease-out, color 120ms ease-out;
  text-align: left;
  font-family: inherit;

  &:hover {
    border-color: ${({ selected }) => (selected ? '#52D381' : '#5C6168')};
  }

  &:focus-visible {
    outline: none;
    border-color: #52D381;
    box-shadow: 0 0 0 3px rgba(82, 211, 129, 0.18);
  }
`;

export const Glyph = styled.span`
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const ChainLabel = styled.span`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
`;

export const ChainName = styled.span`
  font-size: 16px;
  font-weight: 500;
  line-height: 1.1;
`;

export const ChainSub = styled.span<{ selected: boolean }>`
  font-size: 10px;
  color: ${({ selected }) => (selected ? '#A7A8B2' : '#7A7E8C')};
  line-height: 1.1;
  margin-top: 2px;
`;

export const Check = styled.svg<{ visible: boolean }>`
  margin-left: auto;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  color: #52D381;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transform: scale(${({ visible }) => (visible ? 1 : 0.8)});
  transition: opacity 120ms ease-out, transform 120ms ease-out;
`;
